<template>
  <ul class="text-left mt-4 text-sm fill-green-600 w-80">
    <li class="flex flex-row items-center mb-0">
      <CheckMarkIcon v-if="rules.minLength(password)" class="mr-2" />
      <CheckXIcon v-else class="mr-2" />

      {{ t("registration.password.limitation.12.characters") }}
    </li>
    <li class="flex flex-row mb-0 items-start">
      <CheckMarkIcon v-if="rules.upperLower(password)" class="mr-2" />
      <CheckXIcon v-else class="mr-2" />
      {{ t("registration.password.limitation.case") }}
    </li>
    <li class="flex flex-row items-center mb-0">
      <CheckMarkIcon v-if="rules.number(password)" class="mr-2" />
      <CheckXIcon v-else class="mr-2" />
      {{ t("registration.password.limitation.number") }}
    </li>
    <li class="flex flex-row items-center mb-0">
      <CheckMarkIcon v-if="rules.special(password)" class="mr-2" />
      <CheckXIcon v-else class="mr-2" />

      {{ t("registration.password.limitation.characters") }}
    </li>
  </ul>
</template>

<script setup lang="ts">
import CheckMarkIcon from "../icon/CheckMarkIcon.vue";
import CheckXIcon from "../icon/CheckXIcon.vue";
import { useI18n } from "vue-i18n";
import { computed, watch } from "vue";

const props = defineProps({
  password: {
    type: String,
  },
});

const emit = defineEmits<{
  (e: "is-password-valid", valid: boolean): void;
}>();

watch(
  () => props.password,
  (newPwd, oldPwd) => {
    const valid = Object.values(rules).every((fn) => fn(newPwd));
    emit("is-password-valid", valid);
  }
);

const { t } = useI18n();
const rules = {
  minLength: (val: string) => val.length >= 12,
  upperLower: (val: string) => /[A-Z]/.test(val) && /[a-z]/.test(val),
  number: (val: string) => /\d/.test(val),
  special: (val: string) => /[^A-Za-z0-9\s]/.test(val),
};
</script>
